import { onAutocompleteChangeInForm } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import _ from 'lodash';

export const handleReasonChange =
  ({ setForm, setInForm, validateField }) =>
  (e, option, action) => {
    const { index, fieldname } = e.currentTarget.dataset;
    const notesPath = fieldname.replace('reasons', 'notes');

    if (action === 'removeOption') {
      setForm(prev =>
        _.set(
          prev,
          notesPath,
          _.get(prev, notesPath).filter((__, i) => i !== Number(index)),
        ),
      );
    }

    onAutocompleteChangeInForm({ setInForm, validateField })(e, option);
  };

// A fee the modal hides (deleted, no reasons to offer, or unchanged this edit) can't have its note
// filled in, so it must not block Save either.
export const getIsFeeShown = (fee, { isCicReasonButtonTriggered }) =>
  !!fee.availableReasons &&
  !fee.isDeleted &&
  !(!isCicReasonButtonTriggered && fee.isIterationBPAmountEQ);

// Save is offered on an untouched form only for reasons the user can see and accept.
export const getHasShownFeeReasons = (form, { isCicReasonButtonTriggered }) =>
  _.some(
    form,
    fee => getIsFeeShown(fee, { isCicReasonButtonTriggered }) && !_.isEmpty(fee.reasons),
  );

export const getInitialFormData = (data, { feesWithReason }) =>
  data.map(({ fee }) => {
    const notes = _.get(feesWithReason, [fee.feeTypeId, 'notes'], {});
    const reasons = _.filter(fee.availableReasons, i => !!notes[i.value]);

    return {
      ...fee,
      notes: reasons.map(i => notes[i.value]),
      reasons,
    };
  });
